import fetcher, { paramsFormer } from 'utils/fetcher';
import {
  API_PRACTICA,
  API_SOCIEDADES,
  API_TIPOPRACTICA,
  API_TIPOSERVICIO,
  API_USUARIOSPERFIL,
  APP_CLIENT_ID,
  APP_CLIENT_SECRET,
  API_CURSOS,
} from 'variables';
import { ResponseFetcher } from 'utils/fetcher/types';
import {
  CursoPractica,
  FormadorCurso,
  CursoAuditoria,
  AlumnoPractica,
  AlumnoAuditoria,
  Provincias,
  EstadoCurso,
  FechaMinimaPractica,
  PracticaSeleccionada,
  InstructorPractica,
  CrearPractica,
  Practica,
  PracticaAuditoria,
  PracticasCount,
  EstadoPractica,
  TipoServicio,
  Sociedad,
  JornadaUsuario,
  Estacion,
  TipoPractica,
  PostAnularPracticaRequest,
  PostAuditoriaRequest,
  PostRechazarPracticaRequest,
  PostReclamarPracticaRequest,
  PostValidarPracticaRequest,
  GetFilterCursoPracticaRequest,
  GetFormadoresCursoRequest,
  GetCursosAuditoriaRequest,
  GetAlumnoAuditoriaRequest,
  GetProvinciaRequest,
  GetFilterAlumnoPracticaRequest,
  GetEstadosCursosRequest,
  GetFechaMinimaPracticaRequest,
  GetPracticaSeleccionadaRequest,
  GetCursosActivosJornadaRequest,
  GetInstructoresPracticasRequest,
  CrearPracticaRequest,
  GetPracticasCountRequest,
  GetPracticasRequest,
  GetPracticasAuditoriaRequest,
  GetEstadosPracticaRequest,
  GetTipoServicioRequest,
  GetSociedadesRequest,
  GetJornadasUsuarioRequest,
  GetEstacionesRequest,
  GetTiposPracticaRequest,
  GetInfoUsersRequest,
  InfoUsers,
  GetPracticasAuditoriaCountRequest,
  GetPracticasByJornadaRequest,
  FechaMaximaPractica,
  GetFechaMaximaPracticaRequest,
  GetFilterCursosByInstructoresRequest,
  GetFilterCursosByAlumnosRequest,
  GetFilterInstructoresByAlumnosRequest,
  InstructorData,
  GetFilterAlumnosByInstructoresRequest,
  AlumnoData,
} from 'store/practicas/types';
import { SET_LOADING_HEADER } from 'utils/fetcher/contants';

// CAMBIOS DE ESTADO
// https://epe.api.int.sir.renfe.es/epe/catalogo-int/test-apic/anularPractica
export const postAnularPracticaRequest = async (
  requestBody: PostAnularPracticaRequest,
  token: string
): Promise<ResponseFetcher<null>> =>
  fetcher({
    url: `${API_PRACTICA}anularPractica`,
    options: {
      method: 'POST',
      body: JSON.stringify(requestBody),
      headers: {
        Authorization: token,
        clientId: APP_CLIENT_ID,
        clientSecret: APP_CLIENT_SECRET,
      },
    },
  });

// https://epe.api.int.sir.renfe.es/epe/catalogo-int/test-apic/postAuditoria
export const postAuditoriaRequest = async (
  requestBody: PostAuditoriaRequest,
  token: string
): Promise<ResponseFetcher<null>> =>
  fetcher({
    url: `${API_PRACTICA}postAuditoria`,
    options: {
      method: 'POST',
      body: JSON.stringify(requestBody),
      headers: {
        Authorization: token,
        clientId: APP_CLIENT_ID,
        clientSecret: APP_CLIENT_SECRET,
      },
    },
  });

// https://epe.api.int.sir.renfe.es/epe/catalogo-int/test-apic/rechazarPractica
export const postRechazarPracticaRequest = async (
  requestBody: PostRechazarPracticaRequest,
  token: string
): Promise<ResponseFetcher<null>> =>
  fetcher({
    url: `${API_PRACTICA}rechazarPractica`,
    options: {
      method: 'POST',
      body: JSON.stringify(requestBody),
      headers: {
        Authorization: token,
        clientId: APP_CLIENT_ID,
        clientSecret: APP_CLIENT_SECRET,
      },
    },
  });

// https://epe.api.int.sir.renfe.es/epe/catalogo-int/test-apic/reclamarPractica
export const postReclamarPracticaRequest = async (
  requestBody: PostReclamarPracticaRequest,
  token: string
): Promise<ResponseFetcher<null>> =>
  fetcher({
    url: `${API_PRACTICA}reclamarPractica`,
    options: {
      method: 'POST',
      body: JSON.stringify(requestBody),
      headers: {
        Authorization: token,
        clientId: APP_CLIENT_ID,
        clientSecret: APP_CLIENT_SECRET,
        ...SET_LOADING_HEADER,
      },
    },
  });

// https://epe.api.int.sir.renfe.es/epe/catalogo-int/test-apic/validarPractica
export const postValidarPracticaRequest = async (
  requestBody: PostValidarPracticaRequest,
  token: string
): Promise<ResponseFetcher<null>> =>
  fetcher({
    url: `${API_PRACTICA}validarPractica`,
    options: {
      method: 'POST',
      body: JSON.stringify(requestBody),
      headers: {
        Authorization: token,
        clientId: APP_CLIENT_ID,
        clientSecret: APP_CLIENT_SECRET,
      },
    },
  });

// OTRAS
// https://epe.api.int.sir.renfe.es/epe/catalogo-int/test-apic/getFilterCursoPractica
// OTRAS
// https://epe.api.int.sir.renfe.es/epe/catalogo-int/test-apic/getCursosActivosJornada
export const getFilterCursoPracticaRequest = async (
  requestBody: GetFilterCursoPracticaRequest,
  token: string
): Promise<ResponseFetcher<CursoPractica[]>> =>
  fetcher({
    url: `${API_PRACTICA}getFilterCursoPractica?${paramsFormer(requestBody)}`,
    options: {
      headers: {
        Authorization: token,
        clientId: APP_CLIENT_ID,
        clientSecret: APP_CLIENT_SECRET,
        ...SET_LOADING_HEADER,
      },
    },
  });


// https://epe.api.int.sir.renfe.es/epe/catalogo-int/test-apic/getFormadoresCurso
export const getFormadoresCursosRequest = async (
  requestBody: GetFormadoresCursoRequest,
  token: string
): Promise<ResponseFetcher<FormadorCurso[]>> =>
  fetcher({
    url: `${API_PRACTICA}getFormadoresCurso?${paramsFormer(requestBody)}`,
    options: {
      headers: {
        Authorization: token,
        clientId: APP_CLIENT_ID,
        clientSecret: APP_CLIENT_SECRET,
        ...SET_LOADING_HEADER,
      },
    },
  });



// https://epe.api.int.sir.renfe.es/epe/catalogo-int/test-apic/getCursosAuditoria
export const getCursosAuditoriaRequest = async (
  requestBody: GetCursosAuditoriaRequest,
  token: string
): Promise<ResponseFetcher<CursoAuditoria[]>> =>
  fetcher({
    url: `${API_PRACTICA}getCursosAuditoria?${paramsFormer(requestBody)}`,
    options: {
      headers: {
        Authorization: token,
        clientId: APP_CLIENT_ID,
        clientSecret: APP_CLIENT_SECRET,
        ...SET_LOADING_HEADER,
      },
    },
  });

  export const getCursosAuditoriaByAlumnosRequest = async (
    requestBody: GetCursosAuditoriaRequest,
    token: string
  ): Promise<ResponseFetcher<CursoAuditoria[]>> =>
    fetcher({
      url: `${API_PRACTICA}getCursosAuditoriaByAlumnos?${paramsFormer(requestBody)}`,
      options: {
        headers: {
          Authorization: token,
          clientId: APP_CLIENT_ID,
          clientSecret: APP_CLIENT_SECRET,
          ...SET_LOADING_HEADER,
        },
      },
  });

// https://epe.api.int.sir.renfe.es/epe/catalogo-int/test-apic/getAlumnosAuditoria
export const getAlumnosAuditoriaRequest = async (
  requestBody: GetAlumnoAuditoriaRequest,
  token: string
): Promise<ResponseFetcher<AlumnoAuditoria[]>> =>
  fetcher({
    url: `${API_PRACTICA}getAlumnosAuditoria?${paramsFormer(requestBody)}`,
    options: {
      headers: {
        Authorization: token,
        clientId: APP_CLIENT_ID,
        clientSecret: APP_CLIENT_SECRET,
        ...SET_LOADING_HEADER,
      },
    },
  });
// https://epe.api.int.sir.renfe.es/epe/catalogo-int/test-apic/getProvinciaAuditoria
export const getProvinciaAuditoriaRequest = async (
  requestBody: GetProvinciaRequest,
  token: string
): Promise<ResponseFetcher<Provincias[]>> =>
  fetcher({
    url: `${API_PRACTICA}getProvinciasAuditoria?${paramsFormer(requestBody)}`,
    options: {
      headers: {
        Authorization: token,
        clientId: APP_CLIENT_ID,
        clientSecret: APP_CLIENT_SECRET,
        ...SET_LOADING_HEADER,
      },
    },
  });

// https://epe.api.int.sir.renfe.es/epe/catalogo-int/test-apic/getFilterAlumnoPractica
export const getFilterAlumnoPracticaRequest = async (
  requestBody: GetFilterAlumnoPracticaRequest,
  token: string
): Promise<ResponseFetcher<AlumnoPractica[]>> =>
  fetcher({
    url: `${API_PRACTICA}getFilterAlumnoPractica?${paramsFormer(requestBody)}`,
    options: {
      headers: {
        Authorization: token,
        clientId: APP_CLIENT_ID,
        clientSecret: APP_CLIENT_SECRET,
        ...SET_LOADING_HEADER,
      },
    },
  });

export const getFilterCursosByInstructoresRequest = (
  requestBody: GetFilterCursosByInstructoresRequest,
  token: string
): Promise<ResponseFetcher<CursoPractica>> =>
  fetcher({
    url: `${API_PRACTICA}getCursosByInstructores?${paramsFormer(requestBody)}`,
    options: {
      headers: {
        Authorization: token,
        clientId: APP_CLIENT_ID,
        clientSecret: APP_CLIENT_SECRET,
        ...SET_LOADING_HEADER,
      },
    },
  });

export const getFilterCursosByAlumnosRequest = (
  requestBody: GetFilterCursosByAlumnosRequest,
  token: string
): Promise<ResponseFetcher<CursoPractica>> =>
  fetcher({
    url: `${API_PRACTICA}getCursosByAlumnos?${paramsFormer(requestBody)}`,
    options: {
      headers: {
        Authorization: token,
        clientId: APP_CLIENT_ID,
        clientSecret: APP_CLIENT_SECRET,
        ...SET_LOADING_HEADER,
      },
    },
  });


export const getFilterInstructoresByAlumnosRequest = (
  requestBody: GetFilterInstructoresByAlumnosRequest,
  token: string
): Promise<ResponseFetcher<InstructorData>> =>
  fetcher({
    url: `${API_PRACTICA}getInstructoresByAlumnos?${paramsFormer(requestBody)}`,
    options: {
      headers: {
        Authorization: token,
        clientId: APP_CLIENT_ID,
        clientSecret: APP_CLIENT_SECRET,
        ...SET_LOADING_HEADER,
      },
    },
  });

export const getFilterAlumnosByInstructoresRequest = (
  requestBody: GetFilterAlumnosByInstructoresRequest,
  token: string
): Promise<ResponseFetcher<AlumnoData>> =>
  fetcher({
    url: `${API_PRACTICA}getAlumnosByInstructores?${paramsFormer(requestBody)}`,
    options: {
      headers: {
        Authorization: token,
        clientId: APP_CLIENT_ID,
        clientSecret: APP_CLIENT_SECRET,
        ...SET_LOADING_HEADER,
      },
    },
  });




// https://epe.api.int.sir.renfe.es/epe/catalogo-int/test-apic/getEstadosCursos
export const getEstadosCursosRequest = async (
  requestBody: GetEstadosCursosRequest,
  token: string
): Promise<ResponseFetcher<EstadoCurso[]>> =>
  fetcher({
    url: `${API_PRACTICA}getEstadosCursos?${paramsFormer(requestBody)}`,
    options: {
      headers: {
        Authorization: token,
        clientId: APP_CLIENT_ID,
        clientSecret: APP_CLIENT_SECRET,
      },
    },
  });

// https://epe.api.int.sir.renfe.es/epe/catalogo-int/test-apic/getFechaMinimaPractica
export const getFechaMinimaPracticaRequest = (
  requestBody: GetFechaMinimaPracticaRequest,
  token: string
): Promise<ResponseFetcher<FechaMinimaPractica>> =>
  fetcher({
    url: `${API_PRACTICA}getFechaMinimaPractica?${paramsFormer(requestBody)}`,
    options: {
      headers: {
        Authorization: token,
        clientId: APP_CLIENT_ID,
        clientSecret: APP_CLIENT_SECRET,
        ...SET_LOADING_HEADER,
      },
    },
  });

// https://epe.api.int.sir.renfe.es/epe/catalogo-int/test-apic/getFechaMaximaPractica
export const getFechaMaximaPracticaRequest = (
  requestBody: GetFechaMaximaPracticaRequest,
  token: string
): Promise<ResponseFetcher<FechaMaximaPractica>> =>
  fetcher({
    url: `${API_PRACTICA}getFechaMaximaPractica?${paramsFormer(requestBody)}`,
    options: {
      headers: {
        Authorization: token,
        clientId: APP_CLIENT_ID,
        clientSecret: APP_CLIENT_SECRET,
        ...SET_LOADING_HEADER,
      },
    },
  });

// https://epe.api.int.sir.renfe.es/epe/catalogo-int/test-apic/getFechaMinimaPractica
export const getInfoUsersRequest = async (
  requestBody: GetInfoUsersRequest,
  token: string
): Promise<ResponseFetcher<InfoUsers>> =>
  fetcher({
    url: `${API_USUARIOSPERFIL}getInfoUsers`,
    options: {
      method: 'POST',
      body: JSON.stringify(requestBody),
      headers: {
        ...SET_LOADING_HEADER,
      },
    },
  });

// https://epe.api.int.sir.renfe.es/epe/catalogo-int/test-apic/getPracticaSeleccionada
export const getPracticaSeleccionadaRequest = async (
  requestBody: GetPracticaSeleccionadaRequest,
  token: string
): Promise<ResponseFetcher<PracticaSeleccionada>> =>
  fetcher({
    url: `${API_PRACTICA}getPracticaSeleccionada?${paramsFormer(requestBody)}`,
    options: {
      headers: {
        Authorization: token,
        clientId: APP_CLIENT_ID,
        clientSecret: APP_CLIENT_SECRET,
        ...SET_LOADING_HEADER,
      },
    },
  });

// https://epe.api.int.sir.renfe.es/epe/catalogo-int/test-apic/getPracticaSeleccionada
export const getPracticasByJornadaRequest = async (
  requestBody: GetPracticasByJornadaRequest,
  token: string
): Promise<ResponseFetcher<Practica[]>> =>
  fetcher({
    url: `${API_PRACTICA}getPracticasByJornada?${paramsFormer(requestBody)}`,
    options: {
      headers: {
        Authorization: token,
        clientId: APP_CLIENT_ID,
        clientSecret: APP_CLIENT_SECRET,
        ...SET_LOADING_HEADER,
      },
    },
  });

// https://epe.api.int.sir.renfe.es/epe/catalogo-int/test-apic/getCursosActivosJornada
export const getCursosActivosJornadaRequest = async (
  requestBody: GetCursosActivosJornadaRequest,
  token: string
): Promise<ResponseFetcher<CursoPractica[]>> =>
  fetcher({
    url: `${API_PRACTICA}getCursosActivosJornada?${paramsFormer(requestBody)}`,
    options: {
      headers: {
        Authorization: token,
        clientId: APP_CLIENT_ID,
        clientSecret: APP_CLIENT_SECRET,
      },
    },
  });

// https://epe.api.int.sir.renfe.es/epe/catalogo-int/test-apic/getInstructoresPracticas
export const getInstructoresPracticasRequest = async (
  requestBody: GetInstructoresPracticasRequest,
  token: string
): Promise<ResponseFetcher<InstructorPractica[]>> =>
  fetcher({
    url: `${API_PRACTICA}getInstructoresActivos?${paramsFormer(requestBody)}`,
    options: {
      headers: {
        Authorization: token,
        clientId: APP_CLIENT_ID,
        clientSecret: APP_CLIENT_SECRET,
        ...SET_LOADING_HEADER,
      },
    },
  });

// https://epe.api.int.sir.renfe.es/epe/catalogo-int/test-apic/crearPractica
export const crearPracticaRequest = async (
  requestBody: CrearPracticaRequest,
  token: string
): Promise<ResponseFetcher<CrearPractica>> =>
  fetcher({
    url: `${API_PRACTICA}crearPractica`,
    options: {
      method: 'POST',
      body: JSON.stringify(requestBody),
      headers: {
        Authorization: token,
        clientId: APP_CLIENT_ID,
        clientSecret: APP_CLIENT_SECRET,
      },
    },
  });

// https://epe.api.int.sir.renfe.es/epe/catalogo-int/test-apic/getPracticasCount
export const getPracticasCountRequest = async (
  requestBody: GetPracticasCountRequest,
  token: string
): Promise<ResponseFetcher<PracticasCount>> =>
  fetcher({
    url: `${API_PRACTICA}getPracticasCount?${paramsFormer(requestBody)}`,
    options: {
      headers: {
        Authorization: token,
        clientId: APP_CLIENT_ID,
        clientSecret: APP_CLIENT_SECRET,
      },
    },
  });

//@deprecated
// https://epe.api.int.sir.renfe.es/epe/catalogo-int/test-apic/getPracticas
export const getPracticasRequest = async (
  requestBody: GetPracticasRequest,
  token: string
): Promise<ResponseFetcher<Practica[]>> =>
  fetcher({
    url: `${API_PRACTICA}getPracticas?${paramsFormer(requestBody)}`,
    options: {
      headers: {
        Authorization: token,
        clientId: APP_CLIENT_ID,
        clientSecret: APP_CLIENT_SECRET,
        ...SET_LOADING_HEADER,
      },
    },
  });

export const getPracticasRequest2 = async (
  requestBody: GetPracticasRequest
  /* token: string, */
): Promise<ResponseFetcher<Practica[]>> =>
  fetcher({
    url: `${API_PRACTICA}getPracticas?${paramsFormer(requestBody)}`,
    options: {
      headers: SET_LOADING_HEADER,
    },
  });

export const getPracticasCountRequest2 = async (
  requestBody: GetPracticasCountRequest
  /* token: string, */
): Promise<ResponseFetcher<PracticasCount>> =>
  fetcher({
    url: `${API_PRACTICA}getPracticasCount?${paramsFormer(requestBody)}`,
    options: {
      headers: {
        ...SET_LOADING_HEADER
      }
    },
  });

// https://epe.api.int.sir.renfe.es/epe/catalogo-int/test-apic/getPracticasAuditoriaCount
export const getPracticasAuditoriaCountRequest = async (
  requestBody: GetPracticasAuditoriaCountRequest,
  token: string
): Promise<ResponseFetcher<number>> =>
  fetcher({
    url: `${API_PRACTICA}getPracticasAuditoriaCount?${paramsFormer(
      requestBody
    )}`,
    options: {
      headers: {
        Authorization: token,
        clientId: APP_CLIENT_ID,
        clientSecret: APP_CLIENT_SECRET,
        ...SET_LOADING_HEADER,
      },
    },
  });

// https://epe.api.int.sir.renfe.es/epe/catalogo-int/test-apic/getPracticasAuditoria
export const getPracticasAuditoriaRequest = async (
  requestBody: GetPracticasAuditoriaRequest,
  token: string
): Promise<ResponseFetcher<PracticaAuditoria[]>> =>
  fetcher({
    url: `${API_PRACTICA}getPracticasAuditoria?${paramsFormer(requestBody)}`,
    options: {
      headers: {
        Authorization: token,
        clientId: APP_CLIENT_ID,
        clientSecret: APP_CLIENT_SECRET,
        ...SET_LOADING_HEADER,
      },
    },
  });

// https://epe.api.int.sir.renfe.es/epe/catalogo-int/test-apic/getEstadosPractica
export const getEstadosPracticaRequest = async (
  requestBody: GetEstadosPracticaRequest,
  token: string
): Promise<ResponseFetcher<EstadoPractica[]>> =>
  fetcher({
    url: `${API_PRACTICA}getEstadosPractica?${paramsFormer(requestBody)}`,
    options: {
      headers: {
        ...SET_LOADING_HEADER,
      },
    },
  });

// https://epe.api.int.sir.renfe.es/epe/catalogo-int/test-apic/getTipoServicio
export const getTipoServicioRequest = async (
  requestBody: GetTipoServicioRequest,
  token: string
): Promise<ResponseFetcher<TipoServicio[]>> =>
  fetcher({
    url: `${API_TIPOSERVICIO}getTipoServicio?${paramsFormer(requestBody)}`,
    options: {
      headers: {
        Authorization: token,
        clientId: APP_CLIENT_ID,
        clientSecret: APP_CLIENT_SECRET,
        ...SET_LOADING_HEADER,
      },
    },
  });

// https://epe.api.int.sir.renfe.es/epe/catalogo-int/test-apic/getSociedades
export const getSociedadesRequest = async (
  requestBody: GetSociedadesRequest,
  token: string
): Promise<ResponseFetcher<Sociedad[]>> =>
  fetcher({
    url: `${API_SOCIEDADES}getSociedades?${paramsFormer(requestBody)}`,
    options: {
      headers: {
        ...SET_LOADING_HEADER,
      },
    },
  });

// https://epe.api.int.sir.renfe.es/epe/catalogo-int/test-apic/getJornadasUsuario
export const getJornadasUsuarioRequest = async (
  requestBody: GetJornadasUsuarioRequest,
  token: string
): Promise<ResponseFetcher<JornadaUsuario[]>> =>
  fetcher({
    url: `${API_PRACTICA}getJornadasUsuario?${paramsFormer(requestBody)}`,
    options: {
      headers: {
        Authorization: token,
        clientId: APP_CLIENT_ID,
        clientSecret: APP_CLIENT_SECRET,
      },
    },
  });

// https://epe.api.int.sir.renfe.es/epe/catalogo-int/test-apic/getEstaciones
export const getEstacionesRequest = async (
  requestBody: GetEstacionesRequest,
  token: string
): Promise<ResponseFetcher<Estacion[]>> =>
  fetcher({
    url: `${API_PRACTICA}getEstaciones?${paramsFormer(requestBody)}`,
    options: {
      headers: {
        Authorization: token,
        clientId: APP_CLIENT_ID,
        clientSecret: APP_CLIENT_SECRET,
        ...SET_LOADING_HEADER,
      },
    },
  });

// https://epe.api.int.sir.renfe.es/epe/catalogo-int/test-apic/getTiposPractica
export const getTiposPracticaRequest = async (
  requestBody: GetTiposPracticaRequest,
  token: string
): Promise<ResponseFetcher<TipoPractica[]>> =>
  fetcher({
    url: `${API_TIPOPRACTICA}getTiposPractica?${paramsFormer(requestBody)}`,
    options: {
      headers: {
        Authorization: token,
        clientId: APP_CLIENT_ID,
        clientSecret: APP_CLIENT_SECRET,
        ...SET_LOADING_HEADER,
      },
    },
  });
